<template>
  <b-container fluid>
    <b-row>
      <b-col cols="8" offset="1">
        <b-row class="syscoBox text-left" v-if="displayTestInfos">
          <b-col cols="12" id="testContent" class="text-white bg-evaobj pt-2">
            <h5><span class="align-middle">{{ $t('LNG_EVALUATION_INFORMATION', this.lang) }}</span> <span class="fa fa-edit text-left align-middle" v-on:click="displayTestInfos = !displayTestInfos" style="cursor: pointer;"></span></h5>
          </b-col>   
          <b-col cols="12" id="testContent" class="mt-3">
              <h5>{{ $t('LNG_NAME', this.lang) }}: {{this.testName}}<br/>{{ $t('LNG_DISCIPLINE', this.lang) }}: {{this.testDiscipline}}<br/>{{ $t('LNG_DATE', this.lang) }}: {{testDateFormatted}}<br/><br/>
              {{$t('LNG_TOTAL_POINTS', this.lang)}}: {{this.totalPoints}}</h5>
           </b-col>
           <b-col cols="12" v-if="this.testComment !== ''">
              <span><pre>{{ this.testComment }}</pre></span>
           </b-col>
        </b-row>
      </b-col>
    </b-row>
     
    <b-row>
      <b-col cols="8" offset="1">
        <b-row class="syscoBox text-left rounded" v-if="!displayTestInfos">
          <b-col cols="12">
            <b-row>
               <b-col cols="12" class="text-white bg-evaobj rounded"><h5><span class="align-middle">{{ $t('LNG_EDIT_EVALUATION_INFORMATION', this.lang) }}</span></h5></b-col>
            </b-row>
            <b-row><b-col cols="12"><b-alert show variant="danger" v-if="missingDataErrorShown" class="mt-2">{{this.missingDataErrorMsg}}</b-alert></b-col></b-row>
            <b-row><b-col cols="4">{{ $t('LNG_NAME', this.lang) }}<b-form-input v-model="testName" type="text" ref="testName" required :placeholder="$t('LNG_NAME', this.lang)" class="mb-3"></b-form-input></b-col></b-row>
            <b-row><b-col cols="4">{{ $t('LNG_DATE', this.lang) }}<b-form-input v-model="testDateBrut" type="date" :placeholder="$t('LNG_DATE', this.lang)" class="mb-3"></b-form-input></b-col></b-row>
            <b-row><b-col cols="12">{{ $t('LNG_COMMENTS', this.lang) }}<b-form-textarea rows="5" v-model="testComment" id="testComment" :placeholder="$t('LNG_TEST_COMMENTS', this.lang)" class="mb-3"></b-form-textarea></b-col></b-row>
            <b-row>
              <b-col cols="1"><b-button type="button" v-on:click.prevent="displayTestInfos = !displayTestInfos">{{ $t('LNG_CLOSE', lang) }}</b-button></b-col>
              <b-col cols="1"><b-button variant="evaobj" type="button" v-on:click.prevent="saveTestInformation()">{{ $t('LNG_SAVE', lang) }}</b-button></b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="8" offset="1">
        <b-alert :show="successAlertShown"
          dismissible
          variant="evaobj"
          @dismissed="successAlertShown=0"
          @dismiss-count-down="countDownChanged">
        <p>{{sucessAlertMessage}}</p>
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="8" offset="1">
        <div v-for="(exercice, indexe) in exercices">
          <b-row v-bind:class="{'selectedExercice': exerciceIsSelected[indexe]}" class="border pt-2 pb-2" v-on:click="selectExercice(indexe, $event)" style="cursor: pointer;">
           <b-col cols="11" class="text-left">{{$t('LNG_EXERCICE', this.lang)}} {{exercice.exoNumber}} <i style="cursor: pointer;" v-bind:class="{'fa-sort-down': !exerciceIsShown[indexe], 'fa-sort-up': exerciceIsShown[indexe], 'align-top': !exerciceIsShown[indexe]}" class="fa fa-2x" v-on:click.prevent="toggleExercice($event, indexe)"></i></b-col>
           <b-col cols="1" class="text-right">{{totalByExo[indexe]['points']}} {{$t('LNG_PTS', this.lang)}}</b-col>
          </b-row>
          <div v-for="(part, indexePart) in exercice.parts">
            <transition name="fade">
            <b-row v-show="exerciceIsShown[indexe]">
              <b-col cols="11" offset="1" class="text-left" style="cursor: pointer;" v-bind:class="{'selectedExercice': partIsSelected[indexe * 100 + indexePart]}">
                <b-row class="border pt-2" v-on:click.prevent="selectPart(indexe, indexePart)">
                  <b-col cols="10">{{$t('LNG_PART', this.lang)}} {{part.partName}}</b-col>
                  <b-col cols="2" class="text-right">{{totalByExo[indexe]['parts'][part.partName]}} {{$t('LNG_PTS', this.lang)}}</b-col>
                </b-row>
              </b-col>
            </b-row>
            </transition>
            <div v-for="(exo, indexeExo) in part.exercices">
              <transition name="fade">
              <b-row v-show="exerciceIsShown[indexe]">
                <b-col cols="10" offset="2" class="text-left">
                  <b-row style="cursor: pointer;" v-on:click.prevent="selectObjective(exo.exoId)" v-bind:class="{'border-objectifLight': indexeExo %2 !== 0, 'border-objectif': indexeExo %2 === 0, 'objective-selected': objectiveIsSelected[exo.exoId]}" class="pt-1">
                    <b-col cols="10"><span class="fa fa-edit" v-on:click.prevent="chooseObjective(exo.exoId, exo.objId)"></span> {{exo.obj}}</b-col>
                    <b-col cols="2" class="pb-1 pt-1"><b-form-input v-b-tooltip.hover.left="$t('LNG_POINTS', this.lang)" type="text" size="sm" v-model="exo.pts" :value="exo.pts" v-on:change="pointsChanged(exo.exoId, exo.pts)"></b-form-input></b-col>
                  </b-row>
                </b-col>
              </b-row>
              </transition>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
      <b-modal v-model="yesNoModalShown" centered :title="yesNoTitle">
        <b-container fluid>
          <h5>{{yesNoQuestion}}</h5>
        </b-container>
        <div slot="modal-footer">
          <b-button type="button" variant="danger" v-on:click.prevent="yesNoModalShown = !yesNoModalShown">{{ $t('LNG_NO', lang) }}</b-button>
          <b-button type="button" variant="evaobj" v-on:click.prevent="yesNoModal_YES()">{{ $t('LNG_YES', lang) }}</b-button>
        </div>
      </b-modal>
      </b-col>
    </b-row>
    
    <b-modal v-model="modalAddExerciceShown" centered>
      <b-container fluid>
        <b-row><col cols="2">Ajouter </b-col><div class="col-3"><b-form-input size="sm" v-model="numberOfNewExercice" type="number" value="1" min="1"></b-form-input></div> exercice<span v-if="numberOfNewExercice > 1">s&nbsp;</span> {{$t('LNG_ADD_THE_EXERCICE_AT', this.lang)}}</b-row>
        <b-form-group>
          
          <b-form-radio-group name="radioInline" v-model="selectedPosition">                     
            <div v-for="(exercice, indexe) in exercices">
               <b-form-radio :value="indexe">{{indexe+1}}</b-form-radio>
            </div>
            <b-form-radio value="end">{{$t('LNG_AT_THEN_END', this.lang)}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-container>
      <div slot="modal-footer">
        <b-button type="button" v-on:click.prevent="modalAddExerciceShown = !modalAddExerciceShown">{{ $t('LNG_CLOSE', lang) }}</b-button>
        <b-button variant="evaobj" type="button" v-on:click.prevent="addNewExerciceToTest(selectedPosition)">{{ $t('LNG_ADD', lang) }}</b-button>
      </div>
    </b-modal>
   
    <b-modal v-model="modalErroMessageShown" centered :title="$t('LNG_ERROR', this.lang)" header-bg-variant="danger" header-text-variant="light">
      <b-container fluid>
        <h5>{{errorMessage}}</h5>
      </b-container>
      <div slot="modal-footer">
        <b-button type="button" variant="danger" v-on:click.prevent="modalErroMessageShown = !modalErroMessageShown">{{ $t('LNG_OK', lang) }}</b-button>
      </div>
    </b-modal>
    
    <b-modal v-model="fileUploadTestModalShown" centered :title="$t('LNG_JOIN_TEST', this.lang)">
      <div class="alert alert-danger" role="alert" v-if="displayUploadAlert">
        {{ this.uploadedFileErroMessage }}
      </div>
      
      <p class="text-left">{{ $t('LNG_PLEASE_SELECT_A_FILE_WORD', this.lang) }}</p>
      <b-form-file accept=".docx" v-model="wordFile" :state="Boolean(wordFile)" ref="fileinputword" :placeholder="$t('LNG_WORD_FILE', lang)" class="mb-4"/>
      <p class="text-left">{{ $t('LNG_PLEASE_SELECT_A_FILE_PDF', this.lang) }}</p>
      <b-form-file accept=".pdf" v-model="pdfFile" :state="Boolean(pdfFile)" ref="fileinputpdf" :placeholder="$t('LNG_PDF_FILE', lang)" />
      <div slot="modal-footer">
         <b-button type="button" v-on:click.prevent="fileUploadTestModalShown = !fileUploadTestModalShown">{{ $t('LNG_CANCEL', this.lang) }}</b-button>
         <b-button type="button" variant="evaobj" v-on:click.prevent="uploadFileTest()">{{ $t('LNG_ADD', this.lang) }}</b-button>
      </div>
   </b-modal>
   
   <b-modal v-model="spinnerModalShown" centered>
     <b-container fluid>
        <b-progress :value="progressBarValue" variant="success" striped class="mb-2"></b-progress>
     </b-container>
     <div slot="modal-footer" />
   </b-modal>
     
   <b-modal v-model="modalAddPartShown" centered>
     <b-container fluid>
       <b-row><col cols="2">{{$t('LNG_ADD', lang)}} </b-col><div class="col-3"><b-form-input size="sm" v-model="numberOfNewParts" type="number" value="1" min="1"></b-form-input></div>{{$t('LNG_PART_SMALL', lang)}}<span v-if="numberOfNewParts > 1">s</span>&nbsp;<span v-if="selectedParts !== 'end'"> {{$t('LNG_ADD_THE_PART_AT', this.lang)}}</span></b-row>
       <b-form-group>
         <b-form-radio-group name="radioInline" v-model="selectedPositionPart">
         <b-row v-if="selectedParts !== 'end'"><b-form-radio value="selected">{{ $t('LNG_SELECTED_PART', lang) }}</b-form-radio></b-row>
         <b-row><b-form-radio value="end">{{ $t('LNG_AT_THEN_END', lang) }}</b-form-radio></b-row>
         </b-form-radio-group>
       </b-form-group>
     </b-container>
     <div slot="modal-footer">
       <b-button type="button" v-on:click.prevent="modalAddPartShown = !modalAddPartShown">{{ $t('LNG_CLOSE', lang) }}</b-button>
       <b-button variant="evaobj" type="button" v-on:click.prevent="addNewPartToTest()">{{ $t('LNG_ADD', lang) }}</b-button>
     </div>
   </b-modal>
   
   <b-modal v-model="modalAddObjectivesShown" centered>
     <b-container fluid>
       <b-row><col cols="2">{{ $t('LNG_ADD', lang) }} </b-col><div class="col-3"><b-form-input size="sm" v-model="numberOfNewObjectives" type="number" value="1" min="1"></b-form-input></div> {{$t('LNG_OBJECTIVE_SMALL', lang)}}<span v-if="numberOfNewObjectives > 1">s&nbsp;</span></b-row>
     </b-container>
     <div slot="modal-footer">
       <b-button type="button" v-on:click.prevent="modalAddObjectivesShown = !modalAddObjectivesShown">{{ $t('LNG_CLOSE', lang) }}</b-button>
       <b-button variant="evaobj" type="button" v-on:click.prevent="addNewObjectivesToTest()">{{ $t('LNG_ADD', lang) }}</b-button>
     </div>
   </b-modal>
   
   <b-modal v-model="modalObjectiveSelectionShown" centered size="lg">
     <b-container fluid>
       <b-row>
         <b-col cols="12">
           {{$t('LNG_SELECT_AN_OBJECTIVE', lang)}}
         </b-col>
       </b-row>
       <b-row>
         <b-col cols="12">
           <v-select v-model="selectedObjectiveInList" :options="objectifsList" ref="objectifsListRef"></v-select>
         </b-col>  
       </b-row>
       <b-row>
         <b-col cols="12" class="pt-5">
           {{$t('LNG_ADD_NEW_OBJECTIVE', lang)}}
         </b-col>
       </b-row>
       <b-row>
         <b-col cols="12">
           <b-form-input v-model="newObjectiveText" type="text"></b-form-input>
         </b-col>
       </b-row>
     </b-container>
     <div slot="modal-footer">
       <b-button type="button" v-on:click.prevent="modalObjectiveSelectionShown = !modalObjectiveSelectionShown">{{ $t('LNG_CLOSE', lang) }}</b-button>
       <b-button variant="evaobj" type="button" v-on:click.prevent="affectObjective()">{{ $t('LNG_ADD', lang) }}</b-button>
     </div>
   </b-modal>
 
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import vSelect from 'vue-select'
import { focus } from 'vue-focus'
export default {
  name: 'testEdit',
  components: {
    vSelect
  },
  directives: {
    focus: focus
  },
  data () {
    return {
      displayTestInfos: true, // Utilisé pour savoir s'il faut afficher la boite d'édition des informations du test
      exerciceIsShown: [], // Utilisé pour montrer ou cacher les exercices
      exerciceIsSelected: [], // Utilisé pour montrer ou cacher les exercices
      partIsSelected: [], // Utilisé pour savoir quelle partie est sélectionnée
      objectiveIsSelected: [], // Utilisé pour savoir quel objectif est sélectionné
      testName: '',       // Utilisé dans la boite de dialogue
      testComment: '',    // Utilisé dans la boite de dialogue
      testDiscipline: '', // Utilisé dans la boite de dialogue
      testDateBrut: '', // Utilisé pour avoir un objet date
      exercices: [], // Stocke les informations concernant les exercices
      numberOfNewExercice: 1, // Utilisé pour indiquer combien d'exercice ajouter
      numberOfNewParts: 1, // Utilisé pour indiquer combien de parties ajouter
      numberOfNewObjectives: 1, // Utilisé pour indiquer combien d'objectifs ajouter
      modalAddExerciceShown: false, // Stock l'état d'affichage de la modal d'ajout d'un exercice
      modalAddPartShown: false, // Stocke l'état d'affichage de la modal d'ajout d'une partie
      modalErroMessageShown: false, // Utilisé pour montrer des messages d'erreur
      modalAddObjectivesShown: false, // Utilisé pour afficher la boite de dialogue demandant combien d'objectifs ajouter
      yesNoModalShown: false, // Utilisé pour poser une question OUI/NON à l'utilisateur
      fileUploadTestModalShown: false, // Utilisé pour afficher la boite de dialogue permettant de joindre un test en WORD et PDF
      modalObjectiveSelectionShown: false, // Utilisé pour afficher la boite de dialogue permettant de choisir un objectif
      spinnerModalShown: false, // Utilisé pour montrer un spinner
      successAlertShown: 0, // Utilisé pour montrer un message de succes
      selectedPosition: 'end', // Utilisé pour savoir quel position est sélectionnée lorsque l'on ajoute un exercice
      selectedPositionPart: 'end', // Utilisé pour savoir quel position est sélectionnée lorsque l'on ajoute une partie
      selectedObjective: 0, // Utilisé pour stocker l'id de l'objectif sélectionné
      errorMessage: '', // Utilisé pour afficher un message d'erreur
      yesNoTitle: '', // Titre de la modal yesNo
      yesNoQuestion: '', // Question posée à l'utilisateur
      missingDataErrorShown: false, // Utilisé pour afficher un message d'erreur lors de l'édition des informations d'un test
      missingDataErrorMsg: '', // Message d'erreur à afficher lors de l'édition d'un test
      formData: new FormData(), // Utilisé pour envoyer des fichiers (word et pdf)
      wordFile: null, // Utilisé pour envoyer des fichiers (word et pdf)
      pdfFile: null, // Utilisé pour envoyer des fichiers (word et pdf)
      dismissSecs: 5, // Durée d'affichage de l'information de succès
      sucessAlertMessage: '', // Message affiché dans la boite de dialogue qui indique un succes
      progressBarValue: 0, // Valeur affichée dans la progressbar
      progressBarTimeout: null, // Utilisé pour stopper la mise à jour de la bar de chargement
      yesNoModalType: '', // Utilisé pour saoir l'action à faire après le Oui
      selectedParts: 'end',
      objectifsList: [], // Utilisé pour stocker les objectifs de la liste
      selectedObjectiveInList: null, // Utilisé pour stocker l'objectif choisi
      exerciceIdToLinkObj: null, // Utilisé pour stocker l'id de l'objectif à changer
      newObjectiveText: '', // Text du nouvel objectif
      displayUploadAlert: false // Utilisé pour afficher un message d'erreur lors de l'upload de fichier
    }
  },
  mounted: function () {
    moment.locale('fr-ch')
    this.loadTestData()
    this.loadObjectivesList()
    this.formData.append('method', 'uploadFile')
    this.$parent.isSideBarVisible = true
  },
  beforeDestroy: function () {
    this.$parent.isSideBarVisible = false
  },
  computed: {
    ...mapState([
      'api',
      'fullname',
      'lang'
    ]),
    totalPoints: function () {
      var exosPoints = this.totalByExo
      var total = 0
      exosPoints.forEach(function (val) {
        if (val['points'] !== undefined) {
          total = total + val['points']
        }
      })
      return total
    },
    totalByExo: function () {
      var totalExo = []
      var temp = 0
      var cpt = 0
      this.exercices.forEach(function (element) {
        totalExo[cpt] = []
        totalExo[cpt]['parts'] = []
        if (element['parts'] !== undefined) {
          Object.keys(element['parts']).forEach(function (key2) {
            totalExo[cpt]['parts'][key2] = 0
            Object.keys(element['parts'][key2]['exercices']).forEach(function (key3) {
              if (element['parts'][key2]['exercices'][key3]['pts'] !== '' && element['parts'][key2]['exercices'][key3]['pts'] != null) {
                temp = temp + parseFloat(element['parts'][key2]['exercices'][key3]['pts'])
                totalExo[cpt]['parts'][key2] = totalExo[cpt]['parts'][key2] + parseFloat(element['parts'][key2]['exercices'][key3]['pts'])
              }
            }, this)
          }, this)
        }
        totalExo[cpt]['points'] = temp
        cpt = cpt + 1
        temp = 0
      }, this)
      return totalExo
    },
    testDateFormatted: function () {
      if (moment(this.testDateBrut).isValid()) {
        return moment(this.testDateBrut).format('DD.MM.YYYY')
      }
      return this.testDateBrut
    }
  },
  methods: {
    countDownChanged (dismissCountDown) {
      this.successAlertShown = dismissCountDown
    },
    loadTestData: function () { // Utiliser pour charger les données concernant le test
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getTestData',
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.exercices = []
        this.exercices = Object.keys(response.data.exercices).map(function (k) { return response.data.exercices[k] })

        // console.log(response.data.exercices)
        // this.exercices = response.data.exercices
        var cpt = 0
        Object.keys(this.exercices).forEach(function (key) {
          this.exerciceIsShown[cpt] = true
          this.exerciceIsSelected[cpt] = false
          cpt = cpt + 1
        }, this)

        // console.log(this.partIsSelected)
        this.testName = response.data.name
        this.testDiscipline = response.data.discipline
        this.testComment = response.data.comment
        this.testDateBrut = response.data.date
        this.selectedPosition = 'end'
        this.selectedParts = 'end'
        this.partIsSelected = []
        // console.log(this.exerciceIsSelected)
      })
    },
    loadObjectivesList: function () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getObjectiveList',
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.objectifsList = response.data.objectives
      })
    },
    toggleExercice (event, exerciceNumber) { // Utiliser pour afficher ou cacher un exercice
      event.stopPropagation() // Nécessaire pour ne pas faire une sélection de la ligne après le clic pour fermer l'exercice
      this.exerciceIsShown[exerciceNumber] = !this.exerciceIsShown[exerciceNumber]
      this.$forceUpdate()
    },
    showAddExerciceModal () { // Appeler depuis Vue.app dans la sidebar pour l'ajout d'un exercice
      this.modalAddExerciceShown = !this.modalAddExerciceShown
    },
    showAddPartModal () { // Appeler depuis Vue.app dans la sidebar pour l'ajout d'une partie
      if (this.selectedParts === 'end' && this.selectedPosition === 'end') {
        this.errorMessage = this.$t('LNG_YOU_NEED_TO_SELECTED_AN_EXERCICE_OR_A_PART', this.lang)
        this.modalErroMessageShown = true
        return
      }
      this.modalAddPartShown = !this.modalAddPartShown
    },
    addNewExerciceToTest (position) { // Utilisé pour ajouter un exercice dans la base de données
      this.modalAddExerciceShown = !this.modalAddExerciceShown
      // Ajouter l'exercice dans la base de donnée
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'addExerciceToTest',
          id: this.$route.params.testId,
          position: this.selectedPosition,
          number: this.numberOfNewExercice
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.loadTestData()
      })
    },
    selectExercice (position, event) { // Utilisé pour sélectionner un exercice
      event.stopPropagation()
      if (this.selectedPosition !== 'end' && this.selectedPosition !== position) { // Enlever la sélection d'un autre exercice
        this.exerciceIsSelected[this.selectedPosition] = !this.exerciceIsSelected[this.selectedPosition]
      }

      if (this.selectedObjective !== 0) { // Si l'objectif est déjà sélectionné
        this.objectiveIsSelected[this.selectedObjective] = false
        this.selectedObjective = 0
      }
      // Ne pas conserver sélectionné la partie
      if (this.selectedParts !== 'end') {
        this.partIsSelected[this.selectedParts] = false
        this.selectedParts = 'end'
      }
      if (this.exerciceIsSelected[position]) {
        this.selectedPosition = 'end'
      } else {
        this.selectedPosition = position
      }
      this.exerciceIsSelected[position] = !this.exerciceIsSelected[position]
      this.$forceUpdate()
    },
    selectPart (indexExo, indexPart) { // Utilisé pour sélectionner une partie
      // Si un exercice est sélectionné alors il faut le désélectionner
      if (this.selectedPosition !== 'end') {
        this.exerciceIsSelected[this.selectedPosition] = !this.exerciceIsSelected[this.selectedPosition]
        this.selectedPosition = 'end'
      }

      if (this.selectedObjective !== 0) { // Si l'objectif est déjà sélectionné
        this.objectiveIsSelected[this.selectedObjective] = false
        this.selectedObjective = 0
      }

      if (this.partIsSelected[100 * indexExo + indexPart]) {
        this.partIsSelected[this.selectedParts] = false
        this.selectedParts = 'end'
        this.selectedPositionPart = 'end'
      } else {
        // Supprimer l'ancien qui était sélectionné
        if (this.selectedParts !== 'end') {
          this.partIsSelected[this.selectedParts] = false
        }
        this.selectedParts = 100 * indexExo + indexPart
        this.partIsSelected[this.selectedParts] = true
        this.selectedPositionPart = 'selected'
      }

      this.$forceUpdate()
    },
    showRemoveExerciceModal () { // Utilisé pour afficher un message qui demande si l'exercice doit vraiment être supprimé
      if (this.selectedPosition === 'end') { // Message d'erreur indiquant qu'il faut au moins sélectionner un exercice
        this.errorMessage = this.$t('LNG_YOU_MUST_SELECT_AN_EXERCICE', this.lang)
        this.modalErroMessageShown = !this.modalErroMessageShown
      } else {
        // Demander confirmation
        this.yesNoQuestion = this.$t('LNG_DO_YOU_WANT_TO_DELETE_EXERCICE', this.lang, {exoNum: this.selectedPosition + 1})
        this.yesNoTitle = this.$t('LNG_DO_YOU_WANT_TO_CONTINUE', this.lang)
        this.yesNoModalType = 'removeExercice'
        this.yesNoModalShown = !this.yesNoModalShown
      }
    },
    saveTestInformation: function () { // Utilisé pour sauver les données du test
      if (this.testName.length === 0) {
        this.missingDataErrorShown = true
        this.missingDataErrorMsg = this.$t('LNG_MISSING_TEST_NAME', this.lang)
        return
      }
      if (this.testDateBrut.length === 0) {
        this.missingDataErrorShown = true
        this.missingDataErrorMsg = this.$t('LNG_TEST_MISSING_DATE', this.lang)
        return
      }
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'updateTestInformation',
          name: this.testName,
          date: this.testDateBrut,
          comment: this.testComment,
          testId: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.data.status === 'OK') {
          this.missingDataErrorShown = false
          this.displayTestInfos = true
        } else {
          this.missingDataErrorShown = true
        }
      })
    },
    pointsChanged: function (id, pts) { // Utilisé pour sauver les points dans la base de données lorsque ceux-ci sont modifiés
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'savePointsToExo',
          id: id,
          pts: pts
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {})
    },
    uploadFileTest: function () { // Utilisé pour l'envoi des fichiers word et pdf au serveur
      this.formData = new FormData()
      this.formData.append('method', 'uploadFile')
      if (this.wordFile !== null) {
        this.formData.append('wordFile', this.wordFile, this.wordFile.name)
      }
      if (this.pdfFile !== null) {
        this.formData.append('pdfFile', this.pdfFile, this.pdfFile.name)
      }
      this.axios({
        method: 'post',
        url: this.api + '?method=uploadTestFile&testId=' + this.$route.params.testId,
        data: this.formData,
        headers: {'Content-Type': 'multipart/form-data'}
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            this.fileUploadTestModalShown = false
            this.sucessAlertMessage = this.$t('LNG_TEST_FILE_WAS_UPLOADED', this.lang)
            this.successAlertShown = this.dismissSecs
          } else {
            var pdf = false
            var docx = false
            response.data.errors.forEach((e) => {
              if (e === 'docx') {
                docx = true
              }
              if (e === 'pdf') {
                pdf = true
              }
            })
            if (pdf & docx) {
              this.uploadedFileErroMessage = this.$t('LNG_UPLOADED_FILE_NOT_PDF_NOT_WORD', this.lang)
            } else if (pdf) {
              this.uploadedFileErroMessage = this.$t('LNG_UPLOADED_FILE_NOT_PDF', this.lang)
            } else if (docx) {
              this.uploadedFileErroMessage = this.$t('LNG_UPLOADED_FILE_NOT_WORD', this.lang)
            }
            this.displayUploadAlert = true
          }
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    progressBarUpload: function () { // Mise à jour de la barre de défilement
      if (this.progressBarValue === 100) {
        this.progressBarValue = 0
      } else {
        this.progressBarValue = this.progressBarValue + 10
      }
    },
    back: function () { // Revenir en arrière
      this.$router.push({ path: '/' })
    },
    yesNoModal_YES: function () { // Action effectuée lors du retour de la modal yes_no
      if (this.yesNoModalType === 'removeExercice') {
        // remove selected exercice
        this.removeSelectedExercice()
      }
      if (this.yesNoModalType === 'removePart') {
        // remove selected part
        this.removeSelectedPart()
        this.yesNoModalShown = !this.yesNoModalShown
      }
      if (this.yesNoModalType === 'removeObjective') {
        this.removeSelectedObjective()
        this.yesNoModalShown = !this.yesNoModalShown
      }
    },
    removeSelectedExercice: function () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'removeExercice',
          number: this.selectedPosition + 1,
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            this.yesNoModalShown = !this.yesNoModalShown
            this.sucessAlertMessage = this.$t('LNG_EXERCICE_DELETED', this.lang)
            // TODO gerer la prochaine selection
            this.successAlertShown = this.dismissSecs
            this.loadTestData()
          }
        }
      })
    },
    toggleAllExercices: function () {
      var cpt = 0
      this.exerciceIsShown.forEach(function (e) {
        this.exerciceIsShown[cpt] = false
        cpt = cpt + 1
      }, this)
      this.$forceUpdate()
    },
    addNewPartToTest: function () { // Utiliser pour l'ajout d'une partie
      var sExo = ''
      if (this.selectedPosition !== 'end') {
        sExo = this.selectedPosition + 1
      }
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'addPartToTest',
          typeOfInsert: this.selectedPositionPart,
          position: this.selectedParts,
          id: this.$route.params.testId,
          quantity: this.numberOfNewParts,
          exercice: sExo
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            this.modalAddPartShown = false
            this.loadTestData()
          } else {
            this.missingDataErrorShown = true
            this.missingDataErrorMsg = this.$t('LNG_COULD_NOT_ADD_PARTS', this.lang)
          }
        }
      })
    },
    showRemovePartModal: function () {  // Utilisé pour demander confirmation de la suppression de la partie
      if (this.selectedParts === 'end') {
        this.modalErroMessageShown = true
        this.errorMessage = this.$t('LNG_MISSING_PART_SELECTION', this.lang)
      } else {
        // Demander confirmation
        this.yesNoQuestion = this.$t('LNG_DO_YOU_WANT_TO_DELETE_PART', this.lang)
        this.yesNoTitle = this.$t('LNG_DO_YOU_WANT_TO_CONTINUE', this.lang)
        this.yesNoModalType = 'removePart'
        this.yesNoModalShown = !this.yesNoModalShown
      }
    },
    removeSelectedPart: function () { // Utilisé pour supprimer une partie
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'removePartFromTest',
          part: this.selectedParts,
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            this.loadTestData()
          } else {
            this.modalErroMessageShown = true
            this.errorMessage = this.$t('LNG_COULD_NOT_REMOVE_PART', this.lang)
          }
        }
      })
    },
    howManyObjectivesToAdd: function () { // Utilisé pour savoir combien d'objectifs ajouter
      if (this.selectedParts === 'end') {
        this.modalErroMessageShown = true
        this.errorMessage = this.$t('LNG_MISSING_PART_SELECTION', this.lang)
        return
      }
      // Afficher la boite de dialogue pour demander combien d'exercice ajouter
      this.modalAddObjectivesShown = true
    },
    addNewObjectivesToTest: function () { // Utilisé pour ajouter un objectif dans une partie
      // Vérifier qu'une partie soit sélectionnée
      if (this.selectedParts === 'end') {
        this.modalErroMessageShown = true
        this.errorMessage = this.$t('LNG_MISSING_PART_SELECTION', this.lang)
      } else {
        // Ajouter une ligne dans la partie sélectionnée
        this.axios({
          method: 'post',
          url: this.api,
          data: {
            method: 'addObjectiveToPartInTest',
            part: this.selectedParts,
            id: this.$route.params.testId,
            quantity: this.numberOfNewObjectives
          },
          transformRequest: [function (data) {
            var qs = require('qs')
            return qs.stringify(data, {arrayFormat: 'brackets'})
          }]
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.status === 'OK') {
              this.loadTestData()
              this.modalAddObjectivesShown = false
            } else {
              this.modalErroMessageShown = true
              this.errorMessage = this.$t('LNG_COULD_NOT_ADD_OBJECTIVE', this.lang)
            }
          }
        })
      }
    },
    selectObjective: function (exoId) {
   // Si un exercice est sélectionné alors il faut le désélectionner
      if (this.selectedPosition !== 'end') {
        this.exerciceIsSelected[this.selectedPosition] = !this.exerciceIsSelected[this.selectedPosition]
        this.selectedPosition = 'end'
      }
   // Si un exercice est sélectionné alors il faut le désélectionner
      if (this.selectedParts !== 'end') {
        this.partIsSelected[this.selectedParts] = false
        this.selectedPart = 'end'
      }
      if (exoId === this.selectedObjective) { // Si l'objectif est déjà sélectionné
        this.selectedObjective = 0
        this.objectiveIsSelected[exoId] = false
      } else {
        this.objectiveIsSelected[this.selectedObjective] = false
        this.objectiveIsSelected[exoId] = true
        this.selectedObjective = exoId
      }
      this.$forceUpdate()
    },
    showRemoveObjectiveModal: function () {
      if (this.selectedObjective === 0) {
        this.modalErroMessageShown = true
        this.errorMessage = this.$t('LNG_MISSING_OBJECTIVE_SELECTION', this.lang)
      } else {
        // Demander confirmation
        this.yesNoQuestion = this.$t('LNG_DO_YOU_WANT_TO_DELETE_OBJECTIVE', this.lang)
        this.yesNoTitle = this.$t('LNG_DO_YOU_WANT_TO_CONTINUE', this.lang)
        this.yesNoModalType = 'removeObjective'
        this.yesNoModalShown = !this.yesNoModalShown
      }
    },
    removeSelectedObjective: function () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'removeSelectedObjective',
          exercice: this.selectedObjective,
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            this.loadTestData()
          } else {
            this.modalErroMessageShown = true
            this.errorMessage = this.$t('LNG_COULD_NOT_REMOVE_OBJECTIVE', this.lang)
          }
        }
      })
    },
    chooseObjective: function (exoId, objId) {
      this.exerciceIdToLinkObj = exoId
      this.modalObjectiveSelectionShown = true
      var label = ''
      this.objectifsList.forEach(function (e) {
        if (e.value === objId) {
          label = e.label
        }
      }, this)
      if (objId !== null) {
        this.selectedObjectiveInList = {value: objId, label: label}
      }
      // TODO ne fonctionne pas
      this.$refs.objectifsListRef.$refs.search.focus()
    },
    affectObjective: function () {
      // Vérifier si au moins un des deux est renseigné
      if (this.selectedObjectiveInList === null && this.newObjectiveText === '') {
        // Afficher un message d'erreur
        this.modalErroMessageShown = true
        this.errorMessage = this.$t('LNG_YOU_MUST_SELECT_AN_OBJ_OR_TYPE_ONE', this.lang)
        return
      }
      // Vérifier si au moins un des deux est renseigné
      if (this.selectedObjectiveInList !== null && this.newObjectiveText !== '') {
        // Afficher un message d'erreur
        this.modalErroMessageShown = true
        this.errorMessage = this.$t('LNG_YOU_MUST_SELECT_AN_OBJ_OR_A_TYPE_ONE', this.lang)
        return
      }

      var selection
      if (this.selectedObjectiveInList == null) {
        selection = -1
      } else {
        selection = this.selectedObjectiveInList.value
      }
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'affectObjective',
          exercice: this.exerciceIdToLinkObj,
          id: this.$route.params.testId,
          text: this.newObjectiveText,
          selection: selection
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            this.modalObjectiveSelectionShown = false
            this.newObjectiveText = ''
            this.selectedObjectiveInList = null
            this.loadTestData()
            this.loadObjectivesList()
          } else {
            this.modalErroMessageShown = true
            this.errorMessage = this.$t('LNG_OBJECTIVE_COULD_NOT_BE_AFFECTED', this.lang)
          }
        }
      })
    },

    // ************ MENU *****************************************************
    uploadFileMenu: function () { // Affiche la boite ed dialogue permettant de choisir le word et le pdf qui correspondent au test
      this.wordFile = null
      this.pdfFile = null
      this.fileUploadTestModalShown = true
    },
    importObjectivesMenu: function (event) { // Permet d'importer automatiquement les objectifs et les points dans le test
      if (this.$store.getters.licence === '1') {
        this.spinnerModalShown = true
        this.progressBarValue = 0
        this.progressBarTimeout = window.setInterval(this.progressBarUpload, 200)
        this.axios({
          method: 'post',
          url: this.api,
          data: {
            method: 'importObjectives',
            id: this.$route.params.testId
          },
          transformRequest: [function (data) {
            var qs = require('qs')
            return qs.stringify(data, {arrayFormat: 'brackets'})
          }]
        })
        .then((response) => {
          if (response.data.status === 'OK') {
            this.progressBarValue = 100
            this.spinnerModalShown = false
            clearInterval(this.progressBarTimeout)
            this.sucessAlertMessage = this.$t('LNG_OBJECTIVES_EXTRACTED', this.lang)
            this.successAlertShown = this.dismissSecs
            this.loadTestData()
          } else {
            this.errorMessage = this.$t('LNG_OBJECTIVES_NOT_EXTRACTED', this.lang)
            this.modalErroMessageShown = !this.modalErroMessageShown
          }
        })
      } else {
        this.showAlertNoLicence = true
      }
    },
    enterResultsMenu: function () {
      this.$router.push({ path: '/results/' + this.$route.params.testId })
    },
    enterBaremeMenu: function () {
      this.$router.push({ path: '/bareme/' + this.$route.params.testId })
    },
    printReportMenu: function () {
      this.spinnerModalShown = true
      this.progressBarValue = 0
      this.progressBarTimeout = setInterval(this.progressBarUpload, 800)
      if (this.$store.getters.licence === '1') {
        this.axios({
          method: 'post',
          url: this.api,
          data: {
            method: 'createPdf',
            testId: this.$route.params.testId
          },
          transformRequest: [function (data) {
            var qs = require('qs')
            return qs.stringify(data, {arrayFormat: 'brackets'})
          }]
        })
        .then((response) => {
          this.progressBarValue = 100
          this.spinnerModalShown = false
          clearInterval(this.progressBarTimeout)
          window.open(this.api + '?method=getPdf&name=' + response.data.name)
        })
      } else {
        this.showAlertNoLicence = true
      }
    },
    printStudentGradeMenu: function () {
      this.spinnerModalShown = true
      this.progressBarValue = 0
      this.progressBarTimeout = setInterval(this.progressBarUpload, 800)
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'createPdfStudentGrade',
          testId: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.progressBarValue = 100
        this.spinnerModalShown = false
        clearInterval(this.progressBarTimeout)
        window.open(this.api + '?method=getPdf&name=' + response.data.name + '&clientname=notes')
      })
    },
    printGroupFormationMenu: function () {
      this.spinnerModalShown = true
      this.progressBarValue = 0
      this.progressBarTimeout = setInterval(this.progressBarUpload, 800)
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'printGroupFormation',
          testId: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.progressBarValue = 100
        this.spinnerModalShown = false
        clearInterval(this.progressBarTimeout)
        window.open(this.api + '?method=getPdf&name=' + response.data.name + '&clientname=groupes')
      })
    },
    printCommentsMenu: function () {
      this.spinnerModalShown = true
      this.progressBarValue = 0
      this.progressBarTimeout = setInterval(this.progressBarUpload, 800)
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'printComments',
          testId: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.progressBarValue = 100
        this.spinnerModalShown = false
        clearInterval(this.progressBarTimeout)
        window.open(this.api + '?method=getPdf&name=' + response.data.name + '&clientname=commentaires')
      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
<style>
</style>




// WEBPACK FOOTER //
// testEdit.vue?45944776